import { Language } from 'types/language'
import { FAQCategories } from 'features/faq-page/types'

export const faqCategoriesSlugs = {
  [FAQCategories.COMMON]: {
    [Language.DUTCH]: ['over-bolt', 'overstappen', 'verbruik-en-prijs', 'betalen'],
    [Language.FRENCH]: ['au-sujet-de-bolt', 'changement-de-fournisseur', 'consommation-et-prix', 'regler-sa-facture']
  },
  [FAQCategories.MINI_GENERATORS]: {
    [Language.DUTCH]: ['faq-mini-opwekkers'],
    [Language.FRENCH]: ['faq-mini-producteurs']
  },
  [FAQCategories.PRICE_INCREASE]: {
    [Language.DUTCH]: [
      'prijsstijging-algemeen', // Algemeen
      'prijsstijging-afrekening', // Jouw afrekening begrijpen
      'prijsstijging-voorschot', // Verhogen van je voorschot
      'prijsstijging-tussentijds-afrekenen' // Tussentijds afrekenen
    ],
    [Language.FRENCH]: [
      'augmentationduprix-general',
      'augmentationduprix-decompte',
      'augmentationduprix-acompte',
      'augmentationduprix-facture-intermediaire'
    ]
  }
}
